var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 135,
    viewBox: "0 0 116 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 17
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M108.4 50.8C108.4 65 102.6 77.8 93.3 87C84.2 96.1 71.6 101.6 57.7 101.6C43.9 101.6 31.3 96 22.1 87C12.8 77.8 7 65 7 50.8C7 22.7 29.7 0 57.7 0C85.7 0 108.4 22.8 108.4 50.8Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_d_514_15917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2996 24.2002C92.4042 24.2002 93.2996 25.0956 93.2996 26.2002V86.1718C93.2996 86.7022 93.0902 87.2123 92.7089 87.5811C83.6582 96.3337 71.3013 101.6 57.6996 101.6C44.2003 101.6 31.8492 96.2416 22.7058 87.5836C22.3151 87.2137 22.0996 86.6969 22.0996 86.1589V26.2002C22.0996 25.0956 22.995 24.2002 24.0996 24.2002H91.2996Z",
    fill: "url(#paint0_linear_514_15917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter1_d_514_15917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2501 55.5465L45.7344 43.0308C45.3439 42.6403 44.7108 42.6403 44.3202 43.0308L40.9969 46.3542C40.6064 46.7447 40.6064 47.3779 40.9969 47.7684L53.5125 60.2841C53.9031 60.6746 54.5362 60.6746 54.9267 60.2841L58.2501 56.9607C58.6406 56.5702 58.6406 55.937 58.2501 55.5465Z",
    fill: "#559550"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter2_d_514_15917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6754 36.1059L50.3008 55.4804C49.9103 55.8709 49.9103 56.5041 50.3008 56.8946L53.6242 60.218C54.0147 60.6085 54.6479 60.6085 55.0384 60.218L74.413 40.8434C74.8035 40.4529 74.8035 39.8197 74.413 39.4292L71.0896 36.1059C70.6991 35.7153 70.0659 35.7153 69.6754 36.1059Z",
    fill: "#68A463"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M74.9 69.5H40.5C39.9477 69.5 39.5 69.9477 39.5 70.5V73.1C39.5 73.6523 39.9477 74.1 40.5 74.1H74.9C75.4523 74.1 75.9 73.6523 75.9 73.1V70.5C75.9 69.9477 75.4523 69.5 74.9 69.5Z",
    fill: "#8E96AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M74.9 79.6001H40.5C39.9477 79.6001 39.5 80.0478 39.5 80.6001V83.2001C39.5 83.7524 39.9477 84.2001 40.5 84.2001H74.9C75.4523 84.2001 75.9 83.7524 75.9 83.2001V80.6001C75.9 80.0478 75.4523 79.6001 74.9 79.6001Z",
    fill: "#8E96AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M66.0004 89.7998H49.4004C48.8481 89.7998 48.4004 90.2475 48.4004 90.7998V93.3998C48.4004 93.9521 48.8481 94.3998 49.4004 94.3998H66.0004C66.5527 94.3998 67.0004 93.9521 67.0004 93.3998V90.7998C67.0004 90.2475 66.5527 89.7998 66.0004 89.7998Z",
    fill: "#8E96AB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_514_15917",
    x: 0.0996094,
    y: 13.2002,
    width: 115.199,
    height: 121.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_514_15917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_514_15917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_514_15917",
    x: 18.7031,
    y: 31.7378,
    width: 61.8398,
    height: 61.8394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_514_15917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_514_15917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_514_15917",
    x: 28.0078,
    y: 24.813,
    width: 68.6973,
    height: 68.6978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_514_15917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_514_15917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514_15917",
    x1: 38.4318,
    y1: 44.5177,
    x2: 73.0033,
    y2: 98.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB6C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/transactionIcon.a1906fe809cff75519f0e64da1a9d567.svg";
export { ForwardRef as ReactComponent };